import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSiteSettings } from '../context/SiteSettingsContext';

export default function SplashScreen({ onDone }) {
  const [phase, setPhase] = useState('in'); // 'in' | 'out'
  const { settings } = useSiteSettings();
  const logoSrc = settings.logoUrl || '/logo.png';
  const tagline  = settings.tagline  || 'Focus On Quality';

  useEffect(() => {
    // Hold 1.6s → fade out over 0.5s → done
    const t1 = setTimeout(() => setPhase('out'), 1600);
    const t2 = setTimeout(() => onDone(),        2100);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <AnimatePresence>
      {phase === 'in' && (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            background: '#FFFFFF',
          }}
        >
          {/* Logo — fades in and drifts up */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <img
              src={logoSrc}
              alt="House of Sample"
              style={{ height: 110, width: 'auto', objectFit: 'contain', display: 'block' }}
            />
          </motion.div>

          {/* Gold shimmer line sweeps in from left after logo settles */}
          <div style={{ position: 'relative', width: 140, height: 2, marginTop: 14, overflow: 'hidden' }}>
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: '0%' }}
              transition={{ delay: 0.55, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
              style={{
                position: 'absolute', inset: 0,
                background: 'linear-gradient(90deg, transparent, var(--color-accent, #B8A830), transparent)',
              }}
            />
          </div>

          {/* Tagline fades in after the line */}
          <motion.p
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.85, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            style={{
              marginTop: 10,
              fontFamily: '"Playfair Display", Georgia, serif',
              fontStyle: 'italic',
              fontSize: 13,
              letterSpacing: '0.22em',
              color: 'var(--color-accent, #B8A830)',
            }}
          >
            {tagline}
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
